import {
  number_subscribe,
  search_all_policy,
  list_all_policy,
  getPolicyNewCount,
  search_policy_data2,
  search_policy_data,
  set_read,
  list_information,
  list_search,
  list_match,
  list_media,
  policy_publicy_addView,
  read_addView,
  policy_apply_addView,
  policy_addView,
  delete_project,
  detail_apply,
  apply_project,
  add_inform_page_view,
  list_policy_apply,
  list_inform,
  data_applied,
  list_policy,
  list_publicy,
  data_inform,
  data_apply,
  data_publicy,
  list_project,
  list_publicy_center,
  data_policy,
  policy_detail,
  detail_img,
  data_policy_calendar,
} from "@/api/policy";
import { Message } from "element-ui";
export default {
  namespaced: true,
  actions: {
    // 增加申报通知浏览量
    async addInformPageView({ state, commit }: any, data: any) {
      const res: any = await add_inform_page_view(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    async getSubscribeNumber({ state, commit }: any, data: any) {
      const res: any = await number_subscribe(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    async searchAllPolicy({ state, commit }: any, params: any) {
      if (!state.allPolicy) {
        const { code, data, msg }: any = await search_all_policy(params)
          .then((res: any) => {
            return res.data;
          })
          .catch((e: string) => console.error(e));
        commit("setAllPolicy", data ? data : [], { root: true });
        return data ? data : [];
      }
      return state.allPolicy;
    },
    // 获得我的消息列表
    async getInformationList({ state, commit }: any, data: any) {
      const res: any = await list_information(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    async setRead({ state, commit }: any, data: any) {
      const res: any = await set_read(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    async searchPolicyData2({ state, commit }: any, data: any) {
      const res: any = await search_policy_data2(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    async getPolicyNewCount({ state, commit }: any, data: any) {
      const res: any = await getPolicyNewCount(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    async searchPolicyData({ state, commit }: any, data: any) {
      const res: any = await search_policy_data(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    async getAllPolicyList({ state, commit }: any, data: any) {
      const res: any = await list_all_policy(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 获取热词
    async getSearchList({ state, commit }: any, data: any) {
      const res: any = await list_search(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 获得公共的政策匹配接口
    async getMatchList({ state, commit }: any, data: any) {
      const res: any = await list_match(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    async getImgDetail({ state, commit }: any, data: any) {
      const res: any = await detail_img(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    async getMediaList({ state, commit }: any, data: any) {
      const res: any = await list_media(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    async addPublicyPageView({ state, commit }: any, data: any) {
      const res: any = await policy_publicy_addView(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 获取在线兑现详情
    async getApplyDetail({ state, commit }: any, data: any) {
      const res: any = await detail_apply(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 获取申报信息回填
    async getAppliedData({ state, commit }: any, data: any) {
      const res: any = await data_apply(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 获得公示单条数据
    async getPublicyData({ state, commit }: any, data: any) {
      const res: any = await data_publicy(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 获取信息类政策详情
    async getPolicyDetail({ state, commit }: any, data: any) {
      const res: any = await policy_detail(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));

      return res;
    },
    // 获取信息类政策详情 首页日历
    async getPolicyDetailCalendar({ state, commit }: any, data: any) {
      const res: any = await data_policy_calendar(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));

      return res;
    },
    // 获得我的项目列表数据
    async getAppliedList({ state, commit }: any, data: any) {
      const res: any = await list_project(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 我的项目列表数据删除
    async delAppliedList({ state, commit }: any, data: any) {
      const res: any = await delete_project(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 申报通知详情
    async getInformData({ state, commit }: any, data: any) {
      const res: any = await data_inform(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 获取信息类政策
    async getPublicyPolicy({ state, commit }: any, data: any) {
      const res: any = await list_inform(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 获取用户申报项目的内容
    async getApplyData({ state, commit }: any, data: any) {
      const res: any = await data_applied(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 获取所有政策分页
    async getPolicyList({ state, commit }: any, data: any) {
      const res: any = await list_policy(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));

      return res;
    },
    async addReadView({ state, commit }: any, data: any) {
      const res: any = await read_addView(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));

      return res;
    },
    async addApplyPolicyView({ state, commit }: any, data: any) {
      const res: any = await policy_apply_addView(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));

      return res;
    },
    async addPolicyView({ state, commit }: any, data: any) {
      const res: any = await policy_addView(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));

      return res;
    },
    // 获取信息类政策单个数据
    async getPolicyData({ state, commit }: any, data: any) {
      const res: any = await data_policy(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));

      return res;
    },
    // 获取公示分页
    async getPublicyList({ state, commit }: any, data: any) {
      const res: any = await list_publicy(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 获取中心公示分页
    async getCenterPublicyList({ state, commit }: any, data: any) {
      const res: any = await list_publicy_center(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 获取在线兑现列表数据
    async getApplyList({ state, commit }: any, data: any) {
      const res: any = await list_policy_apply(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 申报项目
    async applyProject({ state, commit }: any, data: any) {
      const res: any = await apply_project(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 获取申报通知分页
    async getInformList({ state, commit }: any, data: any) {
      const res: any = await list_inform(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
  },
};
